/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './signPlcOperation.defs'
export { main as default } from './signPlcOperation.defs'
